import React, { useState } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { generateRoutesFromConfigs } from "./RoutesUtils";

export default function AppRoute(props) {


  const [config] = useState([
    ...generateRoutesFromConfigs(props.routes),
  ]);
  return (<BrowserRouter>
    <Routes>
      {config.map((value, index) => (
        <Route key={index} path={value.path} element={<value.component />} />
      ))}
      <Route key={"routes404"} path="*" element={<Navigate to={"/error/404"} />} />
    </Routes>
  </BrowserRouter>
  );
}
